/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import Menu from '../../../../components/InternalMenu/Menu'

import { useForm } from "react-hook-form"
import { get, put } from '../../../../services/http'

import { notify } from '../../../../components/Toast'
import { ToastContainer } from 'react-toastify'

import { useNavigate, useParams } from 'react-router-dom'

export default function index() {
  const navigate = useNavigate()
  document.title = 'ویرایش بنرها'

  const [banners, setBanners] = useState([])

  const { register, handleSubmit, reset } = useForm()

  const token = localStorage.getItem('token')
  const { id } = useParams()

  useEffect(() => {
    get(`/api/admin/im/banners/${id}?token=${token}`)
      .then(response => {
        console.log(response)
        setBanners(response.data.data[0].banners)
        let defaultValues = {}
        reset({ ...defaultValues })
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [id, reset, token])

  const onSubmit = (data, e) => {
    e.preventDefault()
    let banners = [
      { 
        link : data['bannerLink1'],
        pic : data['bannerPic1']
      },
      { 
        link : data['bannerLink2'],
        pic : data['bannerPic2']
      },
      { 
        link : data['bannerLink3'],
        pic : data['bannerPic3']
      },
    ]

    put(`/api/admin/im/banners/${id}?token=${token}`, { banners: banners }).then(response => {
      notify('success', response.data.messageFa)
      setTimeout(() => {
        navigate('/im/banners')
      }, 2000)
    }).catch(error => {
      if (error) {
        notify('error', error)
      }
      notify('error', 'خطا در ارسال اطلاعات')
    })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'banner'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right'>
              <div className='text'>
                جایگاه بنرها
              </div>
            </div>

            <div className='left'>
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * برای ویرایش جایگاه بنرها لطفا تمامی فیلد های مشخص شده را پر کنید.
            </div>
            <div className='lineTitle'>
              <hr />
              اطلاعات بنرها
              <hr />
            </div>
            {banners.map((item, index) => (
              <div className='row' key={index} id={item.id}>
                <div className='column'>
                  <label htmlFor='resturantDay'>لینک * :</label>
                  <input id='resturantDay' {...register(`bannerLink${index+1}`, { required: true, minLength: 1 })} className='ltrdirection' defaultValue={item.link} type='text' placeholder='لینک' />
                  <small id='resturantDayAlert'>ویژگی باید وارد شود</small>
                </div>
                <div className='column'>
                  <label htmlFor='resturantTime'>لینک تصویر * :</label>
                  <input id='resturantTime' {...register(`bannerPic${index+1}`, { required: true, minLength: 3 })} className='ltrdirection' defaultValue={item.pic} type='text' placeholder='لینک تصویر' />
                  <small id='resturantTimeAlert'>انگلیسی ویژگی باید وارد شود</small>
                </div>
              </div>
            ))}
            <button className='createButton'>ثبت</button>
          </form>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
